import React, { useState } from "react"
import { Button, Menu, MenuItem, Tooltip } from "@mui/material"
import HorizontalRuleIcon from "@mui/icons-material/HorizontalRule"
import { ExternalLink } from "../../containers/Transactions/styles"
import { ExternalLinkIcon } from "../../containers/Transactions/ExternalLinkIcon"

export type options = {
  value: string
  name: string
}[]

export const ListingRowMenu = ({
  options,
  name,
}: {
  options: options
  name: string
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  const optionsLength = options?.length ?? 0

  if (optionsLength === 0) {
    return <HorizontalRuleIcon />
  }

  return optionsLength === 1 ? (
    <ExternalLink
      value={options[0].value}
      onClick={() => {
        options[0].value && window.open(options[0].value)
      }}
    >
      {options[0].name}
    </ExternalLink>
  ) : (
    <>
      <Tooltip title="Click to view">
        <Button
          id={`${name}-button`}
          aria-controls={open ? `${name}-menu` : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
          sx={{
            color: "#3753e9",
            padding: 0,
          }}
        >
          {`${optionsLength} ${name}s`}
        </Button>
      </Tooltip>
      <Menu
        id={`${name}-menu`}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": `${name}-button`,
        }}
      >
        {options?.map((option) => {
          return (
            <MenuItem onClick={() => window.open(option.value)}>
              <ExternalLink>
                {option.name}
                <ExternalLinkIcon />
              </ExternalLink>
            </MenuItem>
          )
        })}
      </Menu>
    </>
  )
}
